import React from 'react'

function PageNotFound() {
  return (
    <div className='paagenotfound'>
      <h1  className="display-1">Page Not Found</h1>
    </div>
  )
}

export default PageNotFound
